import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import moment from 'moment';
import { AGENDA_DATE_FORMAT, FLOW_DATE_FORMAT } from '@core/constants';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';

@Component({
    selector: 'app-agenda-datepicker',
    templateUrl: './agenda-datepicker.component.html',
    styleUrls: ['./agenda-datepicker.component.scss'],
    standalone: false
})
export class AgendaDatepickerComponent {
    @Input() value: moment.Moment;
    @Output() changeDay = new EventEmitter<moment.Moment>();
    @ViewChild('picker') datePicker: DatepickerComponent;

    AGENDA_DATE_FORMAT = AGENDA_DATE_FORMAT;

    maxDate = moment().add(1, 'year');

    handleSelectDay(event: any): void {
        this.value = moment(event, FLOW_DATE_FORMAT);
        this.changeDay.emit(this.value);
    }

    openPicker(): void {
        this.datePicker.openDatepicker();
    }
}
